import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-ba5e2464.mjs';
import './Icon-a7b85e86.mjs';
import './FormElementMixin-29581863.mjs';
import { s as script } from './Select-2cca695f.mjs';
export { s as OSelect } from './Select-2cca695f.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
